import { Input, TemplateRef, ViewChild } from '@angular/core';
import { Component } from '@angular/core';

@Component({
  selector: 'app-webeditor',
  templateUrl: './webeditor.component.html',
  styleUrl: './webeditor.component.css',
})
export class WebeditorComponent {

  @Input()
  formControlName: string;
}
